import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from 'hui/src/styled/theme';
import { ErrorText } from '../Field';

const StyledField = styled.textarea`
  width: 100%;
  font-size: 16px;
  border: 0;
  border-radius: 4px;
  margin-top: 8px;
  font-weight: normal;
  outline: 0;
  border: 1px solid ${colors.GREY};
  position: relative;
  padding: 11px 20px;
`;

const StyledLabel = styled.label`
  display: block;
  margin-top: 1rem;
  font-weight: 600;
`;

export default function TextArea({ name, label, placeholder, input, meta, ...rest }) {
  return (
    <StyledLabel>
      <span>{label}</span>
      <StyledField name={name} {...input} {...rest} placeholder={placeholder} />
      {meta.touched && meta.error && <ErrorText>{meta.error}</ErrorText>}
    </StyledLabel>
  );
}

TextArea.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.object
};
